import { createContext, useContext } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail,
} from 'firebase/auth';
import type { IdTokenResult, User, UserCredential, UserProfile } from 'firebase/auth';
import { auth } from '@/firebase';
import type { TUserSubscription } from '@/types/user.types';
import type { TTrackInterviewProgress } from '@/types/digital-twin.types';

interface AuthContextType {
  user: User | null;
  loading: boolean;
  userProfile: UserProfile | null;
  userEntitlements: TUserSubscription | null;
  idTokenResult: IdTokenResult | null;
  userName: string | null;
  interviewProgress: TTrackInterviewProgress | null;
  userIPdata: any;
  localPrices: any;
  refreshUser: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: true,
  userProfile: null,
  userEntitlements: null,
  idTokenResult: null,
  userName: null,
  interviewProgress: null,
  userIPdata: null,
  localPrices: null,
  refreshUser: () => {},
});
export const useAuth = () => useContext(AuthContext);

export const signUp = async (email: string, password: string): Promise<UserCredential> => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const signIn = async (email: string, password: string): Promise<UserCredential> => {
  return await signInWithEmailAndPassword(auth, email, password);
};

export const signOut = async (): Promise<void> => {
  return await firebaseSignOut(auth);
};

export const sendPasswordResetEmail = async (email: string) => {
  await firebaseSendPasswordResetEmail(auth, email);
};
